"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallationCardCms = void 0;
var InstallationCardCms = /** @class */ (function () {
    function InstallationCardCms() {
        this.availableAppointmentRadioLabel = 'I prefer the earliest available appointment.';
        this.emailDateTimeConsentLabel = ' (We\'ll email you the exact date and timeframe.)';
        this.earliestDescriptionLabel = 'Earliest available appointment';
        this.pickSpecificDateLinkLabel = 'Pick a specific day and timeframe';
        this.pickDifferentDateLinkLabel = 'Pick a different date or time';
        this.panelDescriptionLabel = "Standard installations take an average of 4 hours.\n        Some installations may require morning or full-day appointments.";
        this.appointmentPreferenceQuestionLabel = 'Tell us when you prefer an appointment.';
        this.appointmentPreferenceTitleLabel = 'Appointment preference';
        this.firstApptDescription = 'The first available appointment date and time are shown below. You can change the date and time in the boxes provided.';
        this.firstApptDescriptionSMB = 'Change your appointment date and time.';
    }
    return InstallationCardCms;
}());
exports.InstallationCardCms = InstallationCardCms;
//# sourceMappingURL=InstallationCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/InstallationCard/InstallationCard.cms.js
// module id = 956
// module chunks = 8